import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  DisabledButton,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React from 'react';

interface ProgressCardProps {
  icon: IconProp;
  title: string;
  description: string;
  action: () => void;
  actionText: string;
  isActionActive: boolean;
  isActionCompleted: boolean;
}

export const ProgressCard: React.FunctionComponent<ProgressCardProps> = ({
  icon,
  title,
  description,
  action,
  isActionActive,
  actionText,
  isActionCompleted,
}) => {
  return (
    <Card className="h-60 w-60 flex-col items-center">
      <div className="flex flex-col justify-center items-center h-2/5 w-full bg-gradient-to-b from-gray-200 to-gray-100 rounded-t-lg">
        <FontAwesomeIcon className="fa-3x" icon={icon} />
      </div>
      <div className="h-2/5 w-full px-5 py-3">
        <div className="font-medium text-sm" data-testid="progress-card-title">
          <strong>{title}</strong>
        </div>
        <div className="text-sm" data-testid="$progress-card-description">
          <span>{description}</span>
        </div>
      </div>
      <div className="h-1/5 w-full">
        {isActionCompleted ? (
          <div className="flex flex-col h-full rounded-b-lg justify-center items-center bg-success-badge">
            <FontAwesomeIcon
              className="fa-lg text-success-icon"
              icon={faCheck}
            />
          </div>
        ) : (
          <DisabledButton
            className="w-full h-full rounded-b-lg"
            isActive={isActionActive}
            onClick={action}
          >
            {actionText}
          </DisabledButton>
        )}
      </div>
    </Card>
  );
};
